import { ChangeDetectionStrategy, Component, inject, OnInit, ViewEncapsulation } from "@angular/core";
import { KeycloakService } from "@ogs/ngx-keycloak";

@Component({
  selector: "app-core-router",
  templateUrl: "./router.component.html",
  styleUrl: "router.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated
})
export class RouterComponent implements OnInit {
  private readonly _keycloakService: KeycloakService = inject(KeycloakService);

  public ngOnInit (): void {
    this._keycloakService.startAccessTokenUpdate();
  }
}
